// extracted by mini-css-extract-plugin
export default {"tooltip":"VM-z","arrow":"WM-z"};